const img = (n) => `/images/stock/${n}.jpg`;

export const HERO_STATEMENTS = [
  ["DRESS THE MOMENT.", "DEFINE YOURS."],
  ["WEAR THE", "UNEXPECTED."],
  ["WHERE CULTURE", "MEETS CUT."],
  ["INDIA,", "REIMAGINED."],
  ["MADE TO", "BE SEEN."],
];

export const LATEST_EDIT = [
  {
    id: "the-new-edit",
    name: "THE NEW EDIT",
    season: "SS — CURRENT SEASON",
    caption: "Bold silhouettes. Quiet confidence.",
    image: img("g-edit1"),
  },
  {
    id: "smara",
    name: "SMARÁ",
    season: "SPRING / SUMMER 23",
    caption: "Where nostalgia meets modernity.",
    image: img("g-edit2"),
  },
  {
    id: "art-of-print",
    name: "THE ART OF PRINT",
    season: "SIGNATURE STORY",
    caption: "Pattern with a point of view.",
    image: img("g-story1"),
  },
];

export const COLLECTIONS = [
  { id: "the-new-edit", label: "NEW COLLECTION", caption: "Bold silhouettes. Quiet confidence.", image: img("g-edit2") },
  { id: "ready-to-wear", label: "READY TO WEAR", caption: "Ready when you are.", image: "/images/studio-rack.webp" },
  { id: "bespoke", label: "BESPOKE", caption: "Designed around you.", image: img("x-portrait1") },
  { id: "bridal", label: "BRIDAL", caption: "Made for the beginning of forever.", image: img("g-bridal1") },
  { id: "ethnic", label: "ETHNIC", caption: "Heritage, cut differently.", image: img("g-story2") },
  { id: "women", label: "WOMEN", caption: "Wear the unexpected.", image: img("x-editorial1") },
  { id: "men", label: "MEN", caption: "Cut with character.", image: img("g-mens") },
  { id: "kids", label: "KIDS", caption: "Little icons. Big personality.", image: img("g-kids") },
  { id: "past-collections", label: "PAST COLLECTIONS", caption: "NYFW SS/17 · SS/18 · SS/19 · SMARÁ SS/23", image: img("x-fashion1") },
];

export const PRODUCTS = [
  {
    id: "sienna-dress",
    sku: "RB-RTW-001",
    name: "The Sienna Dress",
    collection: "SMARÁ SS/23",
    category: "Ready to Wear",
    price: "₹18,500",
    fabric: "Silk crepe, hand-finished",
    description: "A floor-sweeping silhouette in deep ember — cut to move, made to be remembered.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Ember", "Noir"],
    availability: "Made to order",
    image: img("x-gown"),
  },
  {
    id: "noir-jacket",
    sku: "RB-RTW-002",
    name: "The Noir Jacket",
    collection: "The New Edit",
    category: "Ready to Wear",
    price: "₹24,000",
    fabric: "Structured wool blend",
    description: "Sharp shoulders, softer intent. A statement layer for after dark.",
    sizes: ["S", "M", "L"],
    colors: ["Noir"],
    availability: "In atelier",
    image: img("x-suit1"),
  },
  {
    id: "aarya-saree",
    sku: "RB-ETH-003",
    name: "The Aarya Saree",
    collection: "Ethnic",
    category: "Ethnic",
    price: "₹32,000",
    fabric: "Handloom silk, zari border",
    description: "Heritage weave, contemporary drape. Tradition, interpreted differently.",
    sizes: ["Free size"],
    colors: ["Sindoor", "Ivory"],
    availability: "Made to order",
    image: img("g-bridal2"),
  },
  {
    id: "muse-coord",
    sku: "RB-RTW-004",
    name: "The Muse Co-ord",
    collection: "Ready to Wear",
    category: "Ready to Wear",
    price: "₹14,800",
    fabric: "Tencel twill",
    description: "Two pieces, one attitude. Day-to-evening without missing a beat.",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Teal", "Bone"],
    availability: "In atelier",
    image: img("x-editorial3"),
  },
  {
    id: "ember-lehenga",
    sku: "RB-BRD-005",
    name: "The Ember Lehenga",
    collection: "Bridal",
    category: "Bridal",
    price: "₹68,000",
    fabric: "Raw silk, hand embroidery",
    description: "Not just a bridal outfit. A piece of your story — stitched to last generations.",
    sizes: ["Bespoke only"],
    colors: ["Blush", "Sindoor"],
    availability: "By consultation",
    image: img("g-story1"),
  },
  {
    id: "signature-blouse",
    sku: "RB-RTW-006",
    name: "The Rutu Signature Blouse",
    collection: "The New Edit",
    category: "Ready to Wear",
    price: "₹9,200",
    fabric: "Sheer organza, lined",
    description: "The house signature — sheer intent, structured finish.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Noir"],
    availability: "In atelier",
    image: img("x-portrait1"),
  },
  {
    id: "rajputana-jacket",
    sku: "RB-MEN-007",
    name: "The Rajputana Jacket",
    collection: "Menswear",
    category: "Men",
    price: "₹28,500",
    fabric: "Textured suiting, silk lining",
    description: "Contemporary tailoring with an Indian soul. Cut with character.",
    sizes: ["38", "40", "42", "44"],
    colors: ["Ink check"],
    availability: "Made to order",
    image: img("x-blazer"),
  },
  {
    id: "mira-dress",
    sku: "RB-RTW-008",
    name: "The Mira Dress",
    collection: "Ready to Wear",
    category: "Ready to Wear",
    price: "₹16,400",
    fabric: "Printed cotton silk",
    description: "Lightness. Movement. Attitude — the summer signature.",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Ivory floral"],
    availability: "In atelier",
    image: img("x-white"),
  },
];

export const STORIES = [
  { id: "art-of-the-silhouette", title: "THE ART OF THE SILHOUETTE", caption: "Why proportion changes everything.", image: img("g-edit2") },
  { id: "crafted-in-india", title: "CRAFTED IN INDIA", caption: "Tradition, interpreted differently.", image: "/images/studio-cuffs.webp" },
  { id: "behind-the-look", title: "BEHIND THE LOOK", caption: "From sketchbook to runway.", image: img("g-designer") },
  { id: "the-rutu-woman", title: "THE RUTU WOMAN", caption: "Confident. Individual. Unapologetic.", image: img("x-portrait3") },
];

export const TESTIMONIALS = [
  { quote: "It didn't feel like an outfit. It felt like armour — made exactly for me.", by: "Bridal Client", place: "Mumbai" },
  { quote: "Every fitting felt like a collaboration. The final piece was unmistakably mine.", by: "Bespoke Client", place: "New York" },
  { quote: "People asked where it was from all evening. That says everything.", by: "Client Name", place: "London" },
  { quote: "Craft you can feel in the first touch. Nothing off the rack comes close.", by: "Client Name", place: "Nagpur" },
];

export const INSTA_IMAGES = [
  img("x-sunglasses"), img("x-dress"), img("x-editorial2"),
  img("x-makeup"), img("x-fashion1"), img("x-portrait4"),
];

export const IMAGES = {
  hero: img("g-hero"),
  house: "/images/studio-interior.webp",
  designer: "/images/designer-atelier.webp",
  global: img("x-woman1"),
  bespoke: "/images/studio-label.webp",
  threads: "/images/studio-threads.webp",
  cuffs: "/images/studio-cuffs.webp",
  rack: "/images/studio-rack.webp",
  bridal1: img("g-bridal1"),
  bridal2: img("g-bridal2"),
  wedding: img("x-wedding"),
  mens1: img("g-mens"),
  mens2: img("x-suit2"),
  mens3: img("x-fabric"),
  kids1: img("g-kids"),
  kids2: img("x-kid1"),
  kids3: img("x-kid2"),
  cta: img("x-gown"),
  rack: img("x-coats"),
};

export const MARQUEE_CITIES = ["NEW YORK", "MUMBAI", "PARIS", "MILAN", "LONDON", "DUBAI", "NAGPUR"];

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
